// Ilustraciones decorativas flat (sin marca comercial) para las cards Limpack.
// Fase 2 del brief — extraídas de CardsLimpack.jsx. Paleta Limpack aplicada.
// Ampliar acá el catálogo del brief (dosificador, papel higiénico/cocina,
// esponja, bolsa de basura, lavarropas) cuando se necesiten en templates nuevos.

const GOLD = '#C5A059', GOLD_D = '#a9843f', GOLD_L = '#D9BC7E', TEAL = '#2BBBC9'

export function PeopleIcon({ size = 30, color = '#FFFFFF' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="9" cy="8" r="3.4" fill={color} />
      <circle cx="16.5" cy="9" r="2.7" fill={color} opacity=".8" />
      <path d="M2.5 19.5c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" stroke={color} strokeWidth="2.1" strokeLinecap="round" />
      <path d="M15.5 19.5c0-2.2 1.1-3.9 2.9-4.7 2.6-.4 4.6 1.6 4.6 4.7" stroke={color} strokeWidth="2" strokeLinecap="round" opacity=".8" />
    </svg>
  )
}

export function GiftBox({ size = 104 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden>
      <rect x="14" y="42" width="72" height="46" rx="5" fill={GOLD} />
      <rect x="14" y="42" width="72" height="46" rx="5" fill="url(#gbsh)" />
      <rect x="10" y="32" width="80" height="16" rx="4" fill={GOLD_L} />
      <rect x="43" y="32" width="14" height="56" fill={GOLD_D} opacity=".55" />
      <path d="M50 32c-6-2-16-8-16-16 0-4 3-7 7-7 7 0 9 12 9 23Z" fill={GOLD_L} />
      <path d="M50 32c6-2 16-8 16-16 0-4-3-7-7-7-7 0-9 12-9 23Z" fill={GOLD} />
      <circle cx="50" cy="31" r="5" fill={GOLD_D} />
      <defs>
        <linearGradient id="gbsh" x1="0" y1="42" x2="0" y2="88" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity=".18" /><stop offset="1" stopColor="#000" stopOpacity=".14" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function BottleFlat({ size = 300, accent = TEAL }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" aria-hidden>
      <rect x="34" y="70" width="70" height="96" rx="12" fill={accent} />
      <rect x="34" y="70" width="70" height="96" rx="12" fill="url(#bfg)" />
      <rect x="52" y="40" width="34" height="34" rx="6" fill={accent} />
      <rect x="48" y="34" width="42" height="12" rx="4" fill="#fff" opacity=".9" />
      <rect x="46" y="92" width="46" height="34" rx="5" fill="#fff" opacity=".92" />
      <rect x="116" y="96" width="52" height="70" rx="10" fill="#fff" opacity=".95" />
      <rect x="128" y="66" width="20" height="34" rx="4" fill="#fff" opacity=".85" />
      <path d="M128 66h30l-8 16h-22z" fill={accent} />
      <rect x="152" y="70" width="20" height="8" rx="3" fill={accent} />
      <defs>
        <linearGradient id="bfg" x1="34" y1="70" x2="104" y2="166" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity=".22" /><stop offset="1" stopColor="#000" stopOpacity=".16" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function MapPin({ size = 340, accent = TEAL }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" fill="none" aria-hidden>
      <g stroke="#fff" strokeWidth="3" strokeLinecap="round">
        <path d="M20 60h160M20 100h160M20 140h160" opacity=".35" />
        <path d="M60 20v160M100 20v160M140 20v160" opacity=".35" />
      </g>
      <path d="M100 46c-24 0-42 18-42 42 0 30 42 66 42 66s42-36 42-66c0-24-18-42-42-42Z" fill={accent} />
      <circle cx="100" cy="88" r="16" fill="#fff" />
    </svg>
  )
}
